import { render, staticRenderFns } from "./customer-protection.vue?vue&type=template&id=68e5fb20&scoped=true&"
import script from "./customer-protection.vue?vue&type=script&lang=js&"
export * from "./customer-protection.vue?vue&type=script&lang=js&"
import style0 from "./customer-protection.vue?vue&type=style&index=0&id=68e5fb20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5fb20",
  null
  
)

export default component.exports